import { fromPairs } from 'lodash';
import { Employee } from '~/types';
import featuresWithDefaults from '~/featuresWithDefaults';

const allPermissions = [
  'business.accounts.view',
  'business.accounts.allias.update',
  ...(featuresWithDefaults.ownAccountTransfer.enabled ? ['business.accounts.transfer'] : []),
  //
  'business.profile.view',
  'business.profile.update',
  //
  'business.location.list',
  'business.location.view',
  'business.location.create',
  'business.location.update',
  'business.location.delete',
  //
  'business.terminal.list',
  'business.terminal.view',
  'business.terminal.create',
  'business.terminal.update',
  'business.terminal.issue activation code',
  'business.terminal.make inactive',
  'business.terminal.delete',
  //
  'business.employee.list',
  'business.employee.view',
  'business.employee.create',
  'business.employee.update',
  'business.employee.get access code',
  'business.employee.assign manager and administrator role',
  'business.employee.delete',
  //
  'business.paymentDetails.list',
  'business.paymentDetails.view',
  'business.paymentDetails.create',
  'business.paymentDetails.update',
  'business.paymentDetails.delete',
  //
  'business.transactions.list',
  'business.transactions.view',
  //
  'business.beneficiary.list',
  'business.beneficiary.view',
  'business.beneficiary.create',
  'business.beneficiary.update',
  'business.beneficiary.delete',
  'business.beneficiary.payout',
  //
  ...(featuresWithDefaults.payrolls.enabled
    ? ['business.payrolls.list', 'business.payrolls.view', 'business.payrolls.create']
    : []),
  'business.directTransfer.create',
];

const BUSINESS_ADMINISTRATOR = allPermissions.filter((item) => {
  switch (item) {
    case 'business.terminal.make inactive':
      return false;
    default:
      return true;
  }
});

const BUSINESS_MANAGER = allPermissions.filter((item) => {
  switch (item) {
    case 'business.employee.assign manager and administrator role':
    case 'business.beneficiary.list':
    case 'business.beneficiary.view':
    case 'business.beneficiary.create':
    case 'business.beneficiary.update':
    case 'business.beneficiary.delete':
    case 'business.beneficiary.payout':
    case 'business.accounts.view':
    case 'business.accounts.allias.update':
    case 'business.accounts.transfer':
    case 'business.profile.view':
    case 'business.profile.update':
    case 'business.paymentDetails.create':
    case 'business.paymentDetails.update':
    case 'business.paymentDetails.delete':
    case 'business.payrolls.list':
    case 'business.payrolls.view':
    case 'business.payrolls.create':
    case 'business.location.create':
    case 'business.location.update':
    case 'business.location.delete':
      return false;
    default:
      return true;
  }
});

const getDict = (arr: string[]): Record<string, true> => {
  if (arr.length === 0) return {};
  return fromPairs(arr.map((item) => [item, true]));
};

const BUSINESS_CASHIER: string[] = [];

const BUSINESS_SALES_AGENT: string[] = [];

const permissions: Record<string, string[]> = {
  BUSINESS_ADMINISTRATOR,
  BUSINESS_MANAGER,
  BUSINESS_CASHIER,
  BUSINESS_SALES_AGENT,
};

export function getPermissions(roles: Employee['roles']): {
  roles: Employee['roles'];
  permissions: Record<string, true>;
} {
  let result: Record<string, true> = {};
  roles.forEach((role) => {
    const permissionsList = permissions[role] ?? [];
    result = { ...result, ...getDict(permissionsList) };
  });
  return {
    roles,
    permissions: result,
  };
}

export default permissions;
